const Place = () => {
  return <h1>Blog Articles</h1>;
};

export default Place;
